import Badge, { type BadgeColor } from '@precis-digital/kurama/Badge'
import { TooltipTitleContainer } from '@precis-digital/kurama/Tooltip'
import React from 'react'
import { type ConfigStatus, STATUSES } from 'shared/configStatuses'
import { useTranslation } from 'shared/translations'

interface StatusTooltipTitleProps {
  status: ConfigStatus
  formattedLastUpdate: string
  badgeColor: BadgeColor | undefined
  shouldShowStatusMessageInTitle: boolean
}

const StatusTooltipTitle: React.FC<StatusTooltipTitleProps> = ({
  status,
  formattedLastUpdate,
  badgeColor,
  shouldShowStatusMessageInTitle
}): React.ReactElement => {
  const { t } = useTranslation('common')

  const getTitleMessage = (): string => {
    switch (status) {
      case STATUSES.active:
      case STATUSES.connected:
        return t('everythingIsRunningSmoothly')
      case STATUSES.error:
        return t(`status.error`)
      case STATUSES.disconnected:
        return t(`status.disconnected`)
      case STATUSES.disabled:
        return t(`status.disabled`)
      case STATUSES.running:
        return t('configIsRunning')
      case STATUSES.paused:
        return t('status.paused')
      case STATUSES.pending:
        return t('pending')
      default:
        return t(`status.${status}`)
    }
  }

  if (!shouldShowStatusMessageInTitle) {
    return (
      <TooltipTitleContainer>
        {`${t('lastUpdate')}: ${formattedLastUpdate}`}
        {badgeColor != null && <Badge color={badgeColor ?? 'stone'} variant="lighter" />}
      </TooltipTitleContainer>
    )
  }

  return (
    <TooltipTitleContainer>
      {getTitleMessage()}
      {badgeColor != null && <Badge color={badgeColor ?? 'stone'} variant="lighter" />}
    </TooltipTitleContainer>
  )
}

export default StatusTooltipTitle
